import "./style.css";

export default class Button {
  static selector = ".s-button";

  constructor(block) {
    this.block = block;
  }
}
